import React from "react";
import { DesignIcon } from "../../DesignPrimitives";
import type { IconName } from "../domain/types";
export function Icon({name,size=24,color="#526273",disabled=false}:{name:IconName;size?:number;color?:string;disabled?:boolean}) { return <DesignIcon name={name} size={size} color={color}/>; }
